import axios from '@/axios'
import * as types from '../mutation-types'

export default {
  namespaced: true,

  state: {
    products: []
  },

  actions: {

    fetchAll ({ commit }) {
      return axios.get('/products').then((response) => {
        commit(types.STORE_PRODUCTS, response.data)
        return response.data
      })
    },

    fetch ({ commit }, { slug }) {
      return axios.get(`/products/${slug}`).then((response) => {
        commit(types.STORE_ONE_PRODUCT, response.data)
      })
    },
    filterProducts ({ commit }, filters) {
      return axios.get('search/products', { params: filters }).then((response) => {
        return response.data.categoriesProducts
      })
    }

  },

  mutations: {
    [types.STORE_PRODUCTS] (state, products) {
      state.products = products
    }
  },

  getters: {
    getById: (state) => (id) => state.products.find((t) => t.id === id),
    getBySlug: (state) => (slug) => state.products.find((t) => t.slug === slug)
  }
}
